import type { CSS } from '../theme';

export const popover: CSS = {
  display: 'flex',
  position: 'absolute',
  width: 'fit-content',
  backgroundColor: '$white',
  zIndex: 100,
};
